export type PFBalanceProps = {
  coinId: number;
  amount: number;
  price: number;
};

export type PFProps = {
  title: string;
  balances: PFBalanceProps[];
};

const portfolioData: PFProps[] = [
  {
    title: 'Short',
    balances: [
      {
        coinId: 2861,
        amount: 51000,
        price: 0.0000065,
      },
      {
        coinId: 2243,
        amount: 4200,
        price: 0.000018,
      },
      {
        coinId: 2578,
        amount: 12040,
        price: 0.00000178,
      },
    ],
  },
  {
    title: 'Binance',
    balances: [
      {
        coinId: 1765,
        amount: 4400,
        price: 0.00082,
      },
      {
        coinId: 1925,
        amount: 420,
        price: 0.00043,
      },
      {
        coinId: 2896,
        amount: 12040,
        price: 0.00000125,
      },
      {
        coinId: 2840,
        amount: 32040,
        price: 0.0000048,
      },
      {
        coinId: 2398,
        amount: 15000,
        price: 0.00000095,
      },
    ],
  },
  {
    title: 'Long',
    balances: [
      {
        coinId: 1925,
        amount: 15000,
        price: 0.00034,
      },
      {
        coinId: 2243,
        amount: 300000,
        price: 0.000012,
      },
      {
        coinId: 2578,
        amount: 350000,
        price: 0.0000034,
      },
    ],
  },
  {
    title: 'Kucoin',
    balances: [
      {
        coinId: 1765,
        amount: 5400,
        price: 0.00082,
      },
      {
        coinId: 2896,
        amount: 11040,
        price: 0.00000125,
      },
      {
        coinId: 2840,
        amount: 42040,
        price: 0.0000048,
      },
      {
        coinId: 2398,
        amount: 12000,
        price: 0.00000095,
      },
    ],
  },
  {
    title: 'Kucoin 1',
    balances: [
      {
        coinId: 1765,
        amount: 5400,
        price: 0.00082,
      },
      {
        coinId: 2896,
        amount: 11040,
        price: 0.00000125,
      },
      {
        coinId: 2840,
        amount: 42040,
        price: 0.0000048,
      },
      {
        coinId: 2398,
        amount: 12000,
        price: 0.00000095,
      },
    ],
  },
  {
    title: 'Kucoin 2',
    balances: [
      {
        coinId: 1765,
        amount: 5400,
        price: 0.00082,
      },
      {
        coinId: 2896,
        amount: 11040,
        price: 0.00000125,
      },
      {
        coinId: 2840,
        amount: 42040,
        price: 0.0000048,
      },
      {
        coinId: 2398,
        amount: 12000,
        price: 0.00000095,
      },
    ],
  },
  {
    title: 'Kucoin 3',
    balances: [
      {
        coinId: 1765,
        amount: 5400,
        price: 0.00082,
      },
      {
        coinId: 2896,
        amount: 11040,
        price: 0.00000125,
      },
      {
        coinId: 2840,
        amount: 42040,
        price: 0.0000048,
      },
      {
        coinId: 2398,
        amount: 12000,
        price: 0.00000095,
      },
    ],
  },
  {
    title: 'Kucoin 4',
    balances: [
      {
        coinId: 1765,
        amount: 5400,
        price: 0.00082,
      },
      {
        coinId: 2896,
        amount: 11040,
        price: 0.00000125,
      },
      {
        coinId: 2840,
        amount: 42040,
        price: 0.0000048,
      },
      {
        coinId: 2398,
        amount: 12000,
        price: 0.00000095,
      },
    ],
  },
];

export default portfolioData;



// WEBPACK FOOTER //
// ./src/data/portfolioData.tsx